import ApiClient from './ApiClient';

class ProductAPI extends ApiClient {
  constructor() {
    super('products', { accountScoped: true });
  }
}

export default new ProductAPI();
